import React, { Suspense } from "react";

const MarkdownEditor = React.lazy(() => import("./markdown-editor").then(m => ({ default: m.MarkdownEditor })));

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  minHeight?: string;
  height?: string;
  readOnly?: boolean;
  error?: boolean;
  errorLine?: number;
  className?: string;
  autoFocus?: boolean;
  forceDark?: boolean;
}

export function MarkdownEditorLazy(props: MarkdownEditorProps) {
  return (
    <Suspense fallback={<div>Loading editor...</div>}>
      <MarkdownEditor {...props} />
    </Suspense>
  );
}